<template>
	<div class="Settle-info">
		<h1 style="text-align: center;font-size: 0.35rem; margin-top: 80px;">加入我们</h1>
		<ul class="Customer-Type">
			<li @click="ruleForm.clientKey = 1" :class="ruleForm.clientKey == 1 ? 'li-active' : 'li-moren'">行业用户</li>
			<li @click="ruleForm.clientKey = 0" :class="ruleForm.clientKey == 0 ? 'li-active' : 'li-moren'">供应商</li>
		</ul>

		<!-- 供应商入驻 -->
		<div class="card" v-if="ruleForm.clientKey == 0">
			<div v-for="(item, index) in cardArr" :key="index" @click="settle(item)"
				:class="item.mouseleaveShow ? 'Settle-content Settle-content-enter' : 'Settle-content'"
				@mouseleave="mouseleave($event, item)" @mouseenter="mouseenter($event, item)">
				<img class="card-top-pic" style="width: -webkit-fill-available;height: 190px;" :src="item.img" alt="">
				<div class="card-content card-content-point">
					<div class="Name-Remark" style="padding: 10px;">
						<p>{{ item.name }}</p>
						<p>{{ item.remark }}</p>
					</div>
					<el-button style="height: fit-content;padding: 7px;margin-bottom: 7px;margin-right: 7px;"
						icon="el-icon-back" circle></el-button>
				</div>
			</div>
		</div>

		<!-- 定制师入驻 -->
		<div class="card" v-if="ruleForm.clientKey == 1">
			<div v-for="(item, index) in ptCardArr" :key="index" @click="settle(item)"
				:class="item.mouseleaveShow ? 'Settle-content Settle-content-enter' : 'Settle-content'"
				@mouseleave="mouseleave($event, item)" @mouseenter="mouseenter($event, item)">
				<img style="width: -webkit-fill-available;height: 190px;" class="card-top-pic" :src="item.img" alt="">
				<div class="card-content card-content-point">
					<div class="Name-Remark" style="padding: 10px;">
						<p>{{ item.name }}</p>
						<p>{{ item.remark }}</p>
					</div>
					<el-button style="height: fit-content;padding: 7px;margin-bottom: 7px;margin-right: 7px;"
						icon="el-icon-back" circle></el-button>
				</div>
			</div>
		</div>

		<el-dialog title="" :visible.sync="settleDialogShow" width="25%" :show-close=false>
			<div class="top-logo">
				<img src="../../assets/png/logo-png.png" alt="">
				<p v-if="ruleForm.clientKey == 0">供应商注册</p>
				<p v-if="ruleForm.clientKey == 1">平台注册</p>
			</div>
			<div class="Settle-content-phone">
				<p class="phoneYz">手机号验证</p>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
					<el-form-item label="">
						<el-input prefix-icon="el-icon-user" v-model="ruleForm.nikeName" placeholder="请输入昵称"></el-input>
					</el-form-item>

					<el-form-item label="" prop="phoneNumber">
						<el-input prefix-icon="el-icon-phone" placeholder="请输入手机号码" v-model="ruleForm.phoneNumber"
							class="input-with-select">
							<el-select style="width: 85px;" v-model="selectAreaNo" slot="prepend" placeholder="请选择">
								<el-option label="+86" value="1"></el-option>
							</el-select>
						</el-input>
					</el-form-item>

					<el-form-item label="">
						<el-input style="margin-right: 5px" placeholder="请输入验证码" v-model="ruleForm.code"
							class="input-with-select"></el-input>
						<el-button style="background-color: #3a62d7" type="primary">
							<span v-if="count < 1 || count === ''" @click="verify">获取验证码</span>
							<span v-else>({{ count }}s)后重新获取</span>
						</el-button>
					</el-form-item>

					<el-form-item label="">
						<el-input :type="iconShow ? 'text' : 'password'" style="margin-right: 5px" placeholder="请输入密码"
							v-model="ruleForm.password" class="input-with-select">
							<template slot="append">
								<svg-icon @click="iconShow = !iconShow"
									:iconClass="iconShow ? 'passwordShow' : 'passwordHide'"></svg-icon>
							</template>
						</el-input>
					</el-form-item>

					<el-form-item label="">
						<el-input :type="iconShow1 ? 'text' : 'password'" style="margin-right: 5px" placeholder="请再次确认密码"
							v-model="ruleForm.confirmPassword" class="input-with-select">
							<template slot="append">
								<svg-icon @click="iconShow1 = !iconShow1"
									:iconClass="iconShow1 ? 'passwordShow' : 'passwordHide'"></svg-icon>
							</template>
						</el-input>
					</el-form-item>

					<p style="font-size: 12px;color: #DCDFE6;">亲，注册成功后填写您的入驻信息，审核通过后，即可将您的商品呈现给众多行业用户</p>

					<el-form-item label="">
						<span class="zcButton" style="background-color: #3a62d7" @click="verificationSupplier">注册用户账号</span>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<el-dialog title="" :visible.sync="verifyShow" width="25%" :show-close=false>
			<slide-verify :imgs=imgs style="margin: 0 auto;" ref="slideblock" @success="onSuccess"
				@fail="onFail"></slide-verify>
		</el-dialog>

		<el-dialog title="注册提醒" :visible.sync="companyShow" width="40%" :show-close=false>
			<p style="margin-top: 5px">系统检测该账户下已存在如下公司主体,是否使用?</p>
			<p style="margin-top: 5px">所属机构：麦格仕国际旅行社</p>
			<span class="footer" style="margin-top: 15px;display: flex;justify-content: flex-end;">
				<el-button size="mini" @click="companyShowPoint(0)">不用了，直接生成新的主体</el-button>
				<el-button type="primary" size="mini" @click="companyShowPoint(1)">确认使用该主体</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Api from '@/components/Api/index'
import CountDown from '@/assets/utils/countDown'
export default {
	name: '',
	components: {

	},
	// 定义属性
	data() {
		let checkPhone = (rule, value, callback) => {
			let reg = /^1[3456789]\d{9}$/
			if (!reg.test(value)) {
				callback(new Error('请输入11位手机号'))
			} else {
				callback()
			}
		}

		return {
			companyShowUrl: '',
			uri: '',
			companyShow: false,
			customer: 0, // 0 行业用户 1 供应商
			resultShow: false,
			iconShow: false,
			iconShow1: false,
			isDisable: true,
			timer: null,
			show: true,
			count: "",

			isDisable1: true,
			timer1: null,
			show1: true,

			rules: {
				//  required: true   是否必填，如不设置，则会根据校验规则自动生成
				phoneNumber: { validator: checkPhone, message: '请输入正确的手机号', trigger: 'blur' },
			},

			ruleForm: {
				phoneNumber: '',
				code: '',
				nikeName: '',
				password: '',
				confirmPassword: '',
				bizId: '',
				supplierKey: '',
				clientKey: 0
			},

			imgs: [
				require('../../assets/verify/1 (10).jpg'),
				require('../../assets/verify/1 (11).jpg'),
				require('../../assets/verify/1 (12).jpg'),
				require('../../assets/verify/1 (13).jpg')
			],
			verifyShow: false,
			phoneNumber: '',
			selectAreaNo: '+86',
			settleDialogShow: false,
			cardArr: [
				{
					mouseleaveShow: false,
					img: require('../../assets/jpg/joinuser2.jpg'),
					key: 'a0726839e56dcd7c25977e82a15486ec',
					name: '地接社',
					remark: '口碑说明一切，用了都说好',
				},
				{
					mouseleaveShow: false,
					img: require('../../assets/jpg/joinpro1.jpg'),
					key: '7524fb6196f966e352ffa4d3a50fefff',
					name: '资源方',
					remark: '一个让B端用户和您直接对话的平台'
				},
				{
					mouseleaveShow: false,
					img: require('../../assets/jpg/joinuser3.jpg'),
					key: 'd09996d94d4823d04ae10be5c10d85ce',
					name: '向导/特色达人',
					remark: '一个让B端用户和您直接对话的平台'
				}
			],
			ptCardArr: [
				{
					name: '旅游门店',
					remark: '降低难度 提高能效 定制需求不再愁',
					mouseleaveShow: false,
					img: require('../../assets/png/mendian.jpeg'),
					key: 'aeebfe01929b9a953ef4754a400ba8e1'
				},
				{
					name: '旅行社',
					remark: '方案及报价神器 一切为了快速成单',
					mouseleaveShow: false,
					img: require('../../assets/png/lxsPt.jpg'),
					key: '9c19f924b73161f7c0d18da62b6b6fc4'
				},
				{
					name: '旅游达人',
					remark: '从此摆脱只介绍 无转化',
					mouseleaveShow: false,
					img: require('../../assets/png/daren.jpeg'),
					key: 'f500a9774c72a01835668f6a34e518d1'
				}
			],
		}
	},
	watch: {
	},
	// 计算属性，会监听依赖属性值随之变化
	computed: {},
	// 方法集合
	methods: {
		companyShowPoint(type) {
			if (type == 0) {
				const lastIndex = this.uri.lastIndexOf('&');
				const before = this.uri.slice(0, lastIndex);
				window.open(before)
			}
			if (type == 1) {
				window.open(this.uri)
			}
		},
		verify() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid && this.show) {
					this.verifyShow = true
					this.$nextTick(() => { this.$refs.slideblock.reset(); })
				}
			})
		},
		mouseleave(e, item) {
			item.mouseleaveShow = false
		},
		mouseenter(e, item) {
			item.mouseleaveShow = true
		},
		settle(item) {
			this.settleDialogShow = true
			this.ruleForm = {
				phoneNumber: '',
				code: '',
				nikeName: '',
				password: '',
				confirmPassword: '',
				bizId: '',
				supplierKey: '',
				clientKey: this.ruleForm.clientKey
			}
			this.ruleForm.supplierKey = item.key
		},
		onRefresh(e) {

		},
		onFail(e) {

		},
		onSuccess(e) {
			this.verifyShow = false
			let _data = new CountDown(60)
			_data.getCountDown();
			setInterval(() => {
				this.count = _data.currentSecond()
			}, 1000)
			//发送验证码
			new Api("oauth").sendRegisterCode(this.ruleForm.phoneNumber).then((result) => {
				if (result.status === 200 && result.data !== '') {
					this.ruleForm.bizId = result.data
					this.$message.success("发送成功,请留意手机短信,获取验证码！")
				}
			})
		},
		verificationSupplier() {
			new Api("oauth").verificationCode(this.ruleForm).then(res => {
				if (res.status === 200) {
					this.resultShow = true;
					if (res.data.url) {
						if (res.data.url.indexOf('companyId') !== -1) {
							this.uri = res.data.url
							this.companyShow = true
						} else {
							window.open(res.data.url);
						}
					}
				} else {
					this.$message.error(res.statusText)
				}
			})
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {

	},
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() { }, // 生命周期 - 创建之前
	beforeMount() { }, // 生命周期 - 挂载之前
	beforeUpdate() { }, // 生命周期 - 更新之前
	updated() { }, // 生命周期 - 更新之后
	beforeDestroy() { }, // 生命周期 - 销毁之前
	destroyed() { }, // 生命周期 - 销毁完成
	activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
::v-deep .el-result {
	display: flex;
	flex-direction: row;
}

::v-deep .el-result__icon svg {
	width: 40px;
	height: 40px;
}

::v-deep .el-result .icon-success {
	fill: #FF6637;
}

::v-deep .el-empty__bottom,
::v-deep .el-result__title {
	margin-top: 0px;
	margin-left: 10px;
}
</style>
<style scoped lang="scss">
.zcButton {
	background: #409EFF;
	color: white;
	width: 100%;
	text-align: center;

	&:hover {
		cursor: pointer;
	}
}

.top-logo {
	text-align: center;

	>img {
		width: 80px;
		height: 60px;
	}

	>p {
		font-size: 15px;
		margin-top: 20px;
		color: #d5633e;
	}
}

.card-content {
	color: #B3B3B3;
	text-align: center;
}

.Settle-content-enter {
	transform: scale(1.05);
}

.Settle-info {
	margin-top: 10px;

	.card {
		padding-top: 30px;
		padding-bottom: 30px;
		display: flex;
		justify-content: space-between;
		width: 970px;
		margin: 0 auto;
	}

	.Settle-content {
		width: 285px;
		height: 329px;
		background: white;
		transition: all .5s;

		/deep/ .el-divider--horizontal {
			width: 90%;
			margin: 0 auto;
			margin-top: 20px;
			margin-bottom: 20px;
		}

		.Fine {
			font-size: 20px;
			text-align: center;
			color: #DB4E1A;
		}

		&:hover {
			cursor: pointer;
			// animation: 1s scalaPic;
		}
	}
}

.Settle-top-pic {
	height: 600px;
	width: 100%;
	object-fit: cover;
}

/deep/ .el-dialog__body {
	display: flex;
	justify-content: center;
	flex-direction: column;

	.Settle-content-phone {
		margin-top: 10px;

		.phoneYz {
			display: inline-block;
			width: 65px;
			height: 20px;
			line-height: 20px;
			border-bottom: 2px solid #cfcfcf;
			font-weight: 500;
			font-size: 13px;
		}
	}
}

.Settle-content-phone /deep/ .el-form-item__content {
	margin-left: 0 !important;
	margin-top: 10px;
	display: flex;
}

.Zc-success {
	width: 300px;
	margin: 0 auto;
	font-size: 16px;
	text-align: center;

	>p:nth-child(2) {
		font-weight: 700;
		font-size: 18px;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	>p:nth-child(3) {
		text-align: justify;
		text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
		text-align-last: left;
	}
}

.Customer-Type {
	display: flex;
	justify-content: center;
	margin-top: 30px;

	.li-moren {
		background: white;
		color: gray;
		border: 1px solid rgb(223, 222, 222);
		width: 95px;
		height: 50px;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.li-active {
		background: rgb(255, 102, 55);
		color: white;
		border: 1px solid rgb(223, 222, 222);
		width: 95px;
		height: 50px;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	>li:nth-child(1) {
		margin-right: 10px;
	}

	>li:nth-child(2) {
		margin-left: 10px;
	}

	>li:hover {
		cursor: pointer;
	}
}

.card-content-point {
	background: white;
	padding: 0;
	position: relative;
	top: -6px;
	height: 152px;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;

	.Name-Remark {
		>p:nth-child(1) {
			font-size: 18px;
			margin-bottom: 8px;
			color: #333333;
			text-align: left;
		}

		>p:nth-child(2) {
			font-size: 12px;
			color: #999999;
		}
	}
}

.card-content-point:hover {
	background-color: #4242ff;
	color: white;

	.Name-Remark {
		>p:nth-child(1) {
			font-size: 18px;
			color: white;
		}

		>p:nth-child(2) {
			font-size: 12px;
			color: white;
		}
	}
}
</style>